/* Collection filters, sorting and "Show more rugs". Uses the Section Rendering API. */
(() => {
  const root = document.querySelector('[data-collection]');
  if (!root) return;
  const sectionId = root.dataset.sectionId;
  let controller;
  let priceTimer;

  const fetchSection = async (url) => {
    const u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionId);
    if (controller) controller.abort();
    controller = new AbortController();
    const res = await fetch(u, { signal: controller.signal });
    if (!res.ok) throw new Error(res.status);
    return new DOMParser().parseFromString(await res.text(), 'text/html');
  };

  const buildUrl = () => {
    const form = root.querySelector('[data-facets-form]');
    const params = new URLSearchParams();
    if (form) {
      for (const [k, v] of new FormData(form)) if (v !== '') params.append(k, v);
    }
    const sort = root.querySelector('[data-sort]');
    if (sort && !params.has('sort_by')) params.set('sort_by', sort.value);
    const q = params.toString();
    return `${window.location.pathname}${q ? `?${q}` : ''}`;
  };

  const refresh = async (url) => {
    const results = root.querySelector('[data-results]');
    if (results) results.classList.add('is-loading');
    const openIds = Array.from(root.querySelectorAll('details[open]')).map((d) => d.id);
    const closedIds = Array.from(root.querySelectorAll('details:not([open])')).map((d) => d.id);
    const sheetOpen = root.classList.contains('is-sheet-open');
    const focusedId = document.activeElement && root.contains(document.activeElement) ? document.activeElement.id : null;
    const scroller = root.querySelector('.coll__form');
    const scrollTop = scroller ? scroller.scrollTop : 0;
    try {
      const doc = await fetchSection(url);
      const fresh = doc.querySelector('[data-collection]');
      if (!fresh) { window.location.href = url; return; }
      root.innerHTML = fresh.innerHTML;
      openIds.forEach((id) => { const d = document.getElementById(id); if (d) d.open = true; });
      closedIds.forEach((id) => { const d = document.getElementById(id); if (d && !d.querySelector('input:checked')) d.open = false; });
      if (sheetOpen) root.classList.add('is-sheet-open');
      const newScroller = root.querySelector('.coll__form');
      if (newScroller) newScroller.scrollTop = scrollTop;
      if (focusedId) { const el = document.getElementById(focusedId); if (el) el.focus({ preventScroll: true }); }
      history.replaceState({}, '', url);
    } catch (err) {
      if (err.name !== 'AbortError') window.location.href = url;
    }
  };

  root.addEventListener('change', (e) => {
    if (e.target.matches('[data-sort]') || e.target.closest('[data-facets-form]')) {
      if (e.target.type === 'number') return;
      refresh(buildUrl());
    }
  });
  root.addEventListener('input', (e) => {
    if (e.target.type !== 'number') return;
    clearTimeout(priceTimer);
    priceTimer = setTimeout(() => refresh(buildUrl()), 600);
  });
  root.addEventListener('submit', (e) => {
    if (!e.target.matches('[data-facets-form]')) return;
    e.preventDefault();
    refresh(buildUrl());
  });

  root.addEventListener('click', async (e) => {
    const link = e.target.closest('[data-facet-link]');
    if (link) {
      e.preventDefault();
      refresh(link.href);
      return;
    }
    if (e.target.closest('[data-filters-open]')) {
      root.classList.add('is-sheet-open');
      document.body.classList.add('is-locked');
      const btn = root.querySelector('[data-filters-open]');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      const sheet = root.querySelector('[data-filters-sheet]');
      if (sheet) { sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true'); sheet.querySelector('button').focus(); }
      return;
    }
    if (e.target.closest('[data-filters-close]')) {
      root.classList.remove('is-sheet-open');
      document.body.classList.remove('is-locked');
      const btn = root.querySelector('[data-filters-open]');
      if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
      return;
    }
    const more = e.target.closest('[data-more-button]');
    if (more) {
      e.preventDefault();
      const loading = root.querySelector('[data-more-loading]');
      more.hidden = true;
      if (loading) loading.hidden = false;
      try {
        const doc = await fetchSection(more.href);
        const grid = root.querySelector('[data-grid]');
        const newGrid = doc.querySelector('[data-grid]');
        const newMore = doc.querySelector('[data-more]');
        const firstNew = newGrid ? newGrid.firstElementChild : null;
        if (grid && newGrid) grid.append(...newGrid.children);
        const moreBox = root.querySelector('[data-more]');
        if (moreBox && newMore) moreBox.innerHTML = newMore.innerHTML;
        const link = firstNew && firstNew.querySelector('a');
        if (link) link.focus({ preventScroll: true });
      } catch (err) {
        window.location.href = more.href;
      }
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && root.classList.contains('is-sheet-open')) {
      root.classList.remove('is-sheet-open');
      document.body.classList.remove('is-locked');
    }
  });
})();
